import React from "react";
import { FormattedMessage } from "react-intl";

import RecommendationsList from "./RecommendationsList";
import CompanyDocumentsList from "./CompanyDocumentsList";

class PageContent extends React.Component {

    render() {
        return (
            <div className="page-content-wrapper">
                <div className="company-profile-wrapper">
                    <p id="company-profile-title">
                        <FormattedMessage id="Company.profileTitle"
                            defaultMessage="Company profile"
                            description="Company profile title" />
                    </p>
                    <p id="company-profile-text">
                        <FormattedMessage id="Company.profileTextPart1"
                            defaultMessage="“Personnel and logistics” EOOD was established in Spring of 2016 and it specializes in the transportation of goods within the countries of the European continent."
                            description="Company profile text" />
                        <br />
                        <br />
                        <FormattedMessage id="Company.profileTextPart2"
                            defaultMessage="We have vast experience in the organization and transport of FTL loads /full loads/, LTL transports /partial loads with the option to transfer goods in our warehouses located in Blagoevgrad and Sofia/, as well as transportation of goods requiring temperature control, transportation of harmless waste, personal items, etc."
                            description="Company profile text" />
                        <br />
                        <br />
                        <FormattedMessage id="Company.profileTextPart3"
                            defaultMessage="“Personnel and Logistics” EOOD is a regular member of the Bulgarian National Freight Forwarding Association "
                            description="Company profile text" />
                        <br />
                        <br />
                        <FormattedMessage id="Company.profileTextPart4"
                                defaultMessage=""
                                description="Company profile text" />
                        <br />
                        <br />
                        <p id="CompanyprofileTextPart5">
                        <FormattedMessage id="Company.profileTextPart5"
                            defaultMessage="and of the German association of logistics/BVL/, which guarantees that we maintain professional work ethics and high standards of work."
                            description="Company profile text" />
                        </p>
                        <FormattedMessage id="Company.profileTextPart6"
                            defaultMessage="The company has a transport license for conducting international transport and it is certified according to the international standard for quality ISO 9001:2015 in the sphere of transport and freight forwarding."
                            description="Company profile text" />
                    </p>
                </div>


                <div className="logistics-wrapper">
                    <p ref={this.props.sectionRefs.logisticsRef} id="logistics-title">
                        <FormattedMessage id="Company.logisticsTitle"
                            defaultMessage="Logistics"
                            description="Logistics Title" />
                    </p>
                    <p id="logistics-text">
                        <FormattedMessage id="Company.logisticsTextPart1"
                            defaultMessage="“Personnel and Logistics” EOOD is in partnership with a great number of trusted carriers, while expanding our network of partners in Bulgaria and in Western Europe."
                            description="Logistics text" />
                        <br />
                        <br />
                        <p id="CompanylogisticsTextPart2">
                        <FormattedMessage id="Company.logisticsTextPart2"
                            defaultMessage="Our client’s security and peace of mind is our top priority. That is why we support active freight forwarder’s liability insurance (by “W.Droege & Co”) along with the mandatory CMR insurance on every truck."
                            description="Logistics text" />
                        </p>
                        <FormattedMessage id="Company.logisticsTextPart3"
                            defaultMessage="The positive feedback we receive from our clients and partners motivates us to constantly expand our portfolio with new destinations and services."
                            description="Logistics text" />
                        <br />
                        <FormattedMessage id="Company.logisticsTextPart4"
                            defaultMessage="The positive feedback we receive from our clients and partners motivates us to constantly expand our portfolio with new destinations and services."
                            description="Logistics text" />
                        <br />
                        <FormattedMessage id="Company.logisticsTextPart5"
                            defaultMessage="The positive feedback we receive from our clients and partners motivates us to constantly expand our portfolio with new destinations and services."
                            description="Logistics text" />
                    </p>
                    {/*<p className="recommendations-title">
                        <FormattedMessage id="Company.recommendationsTitle"
                            defaultMessage="Recommendations"
                            description="Recommendations title" />
                    </p>
                    <div className="recommendations-list">
                        <RecommendationsList recommendations={this.props.recommendations}></RecommendationsList>
                    </div>*/}
                </div>

                <div className="transport-wrapper">
                    <p ref={this.props.sectionRefs.transportRef} id="transport-title">
                        <FormattedMessage id="Company.transportTitle"
                            defaultMessage="Transport"
                            description="Transport Service" />
                    </p>
                    <p id="transport-text">
                        <FormattedMessage id="Company.transportTextPart1"
                            defaultMessage="One of the main factors for our success is our correct and responsible approach towards our customers. We are always at your disposal for your inquiries in English, Bulgarian and German languages."
                            description="Transport Service text" />
                        <br />
                        <br />
                        <p id="CompanytransportTextPart2">
                        <FormattedMessage id="Company.transportTextPart2"
                            defaultMessage="Amongst our main principles is the constant investment in expanding our expertise and skillset, new infrastructure and improving organizational workflow."
                            description="Transport Service text" />
                        </p>
                        <FormattedMessage id="Company.transportTextPart3"
                            defaultMessage="Our participation in specialized events such as Munich trade fair for logistics and transport allows us to expand and solidify our network of partners and customers throughout Europe."
                            description="Transport Service text" />
                        <br />
                        <FormattedMessage id="Company.transportTextPart4"
                            defaultMessage="We have successfully completed certified courses for road transport spedition and transport insurance, held by the Bulgarian national freight forwarding association. We continue to build on our expertise and skillset by taking part in specialized training and seminars."
                            description="Transport Service text" />
                        <br />
                        <FormattedMessage id="Company.transportTextPart5"
                            defaultMessage="We have successfully completed certified courses for road transport spedition and transport insurance, held by the Bulgarian national freight forwarding association. We continue to build on our expertise and skillset by taking part in specialized training and seminars."
                            description="Transport Service text" />
                        <br />
                        <FormattedMessage id="Company.transportTextPart6"
                            defaultMessage="We have successfully completed certified courses for road transport spedition and transport insurance, held by the Bulgarian national freight forwarding association. We continue to build on our expertise and skillset by taking part in specialized training and seminars."
                            description="Transport Service text" />
                        <br />
                        <br />
                        <p id="CompanytransportTextPart7">
                        <FormattedMessage id="Company.transportTextPart7"
                            defaultMessage="We have successfully completed certified courses for road transport spedition and transport insurance, held by the Bulgarian national freight forwarding association. We continue to build on our expertise and skillset by taking part in specialized training and seminars."
                            description="Transport Service text" />
                        </p>
                        <FormattedMessage id="Company.transportTextPart8"
                            defaultMessage="We have successfully completed certified courses for road transport spedition and transport insurance, held by the Bulgarian national freight forwarding association. We continue to build on our expertise and skillset by taking part in specialized training and seminars."
                            description="Transport Service text" />
                        <br />
                        <FormattedMessage id="Company.transportTextPart9"
                            defaultMessage="We have successfully completed certified courses for road transport spedition and transport insurance, held by the Bulgarian national freight forwarding association. We continue to build on our expertise and skillset by taking part in specialized training and seminars."
                            description="Transport Service text" />
                        <br />
                        <FormattedMessage id="Company.transportTextPart10"
                            defaultMessage="We have successfully completed certified courses for road transport spedition and transport insurance, held by the Bulgarian national freight forwarding association. We continue to build on our expertise and skillset by taking part in specialized training and seminars."
                            description="Transport Service text" />
                        <br />
                        <FormattedMessage id="Company.transportTextPart11"
                            defaultMessage="We have successfully completed certified courses for road transport spedition and transport insurance, held by the Bulgarian national freight forwarding association. We continue to build on our expertise and skillset by taking part in specialized training and seminars."
                            description="Transport Service text" />
                        <br />
                        <br />
                        <p id="CompanytransportTextPart12">
                        <FormattedMessage id="Company.transportTextPart12"
                            defaultMessage="We have successfully completed certified courses for road transport spedition and transport insurance, held by the Bulgarian national freight forwarding association. We continue to build on our expertise and skillset by taking part in specialized training and seminars."
                            description="Transport Service text" />
                        </p>
                        <FormattedMessage id="Company.transportTextPart13"
                            defaultMessage="We have successfully completed certified courses for road transport spedition and transport insurance, held by the Bulgarian national freight forwarding association. We continue to build on our expertise and skillset by taking part in specialized training and seminars."
                            description="Transport Service text" />
                        <br />
                        <FormattedMessage id="Company.transportTextPart14"
                            defaultMessage="We have successfully completed certified courses for road transport spedition and transport insurance, held by the Bulgarian national freight forwarding association. We continue to build on our expertise and skillset by taking part in specialized training and seminars."
                            description="Transport Service text" />
                        <br />
                        <FormattedMessage id="Company.transportTextPart15"
                            defaultMessage="We have successfully completed certified courses for road transport spedition and transport insurance, held by the Bulgarian national freight forwarding association. We continue to build on our expertise and skillset by taking part in specialized training and seminars."
                            description="Transport Service text" />
                        <br />
                        <FormattedMessage id="Company.transportTextPart16"
                            defaultMessage="We have successfully completed certified courses for road transport spedition and transport insurance, held by the Bulgarian national freight forwarding association. We continue to build on our expertise and skillset by taking part in specialized training and seminars."
                            description="Transport Service text" />
                        <br />
                        <FormattedMessage id="Company.transportTextPart17"
                            defaultMessage="We have successfully completed certified courses for road transport spedition and transport insurance, held by the Bulgarian national freight forwarding association. We continue to build on our expertise and skillset by taking part in specialized training and seminars."
                            description="Transport Service text" />
                        <br />
                        <FormattedMessage id="Company.transportTextPart18"
                            defaultMessage="We have successfully completed certified courses for road transport spedition and transport insurance, held by the Bulgarian national freight forwarding association. We continue to build on our expertise and skillset by taking part in specialized training and seminars."
                            description="Transport Service text" />
                    </p>
                </div>

                <div className="warehousing-wrapper">
                    <p ref={this.props.sectionRefs.warehousingRef} id="warehousing-title">
                        <FormattedMessage id="Company.warehousingTitle"
                            defaultMessage="Warehousing"
                            description="Warehousing Service" />
                    </p>
                    <p id="warehousing-text">
                        <FormattedMessage id="Company.warehousingTextPart1"
                            defaultMessage="One of the main factors for our success is our correct and responsible approach towards our customers. We are always at your disposal for your inquiries in English, Bulgarian and German languages."
                            description="Warehousing Service text" />
                        <br />
                        <br />
                        <p id="CompanywarehousingTextPart2">
                        <FormattedMessage id="Company.warehousingTextPart2"
                            defaultMessage="Amongst our main principles is the constant investment in expanding our expertise and skillset, new infrastructure and improving organizational workflow."
                            description="Warehousing Service text" />
                        </p>
                        <FormattedMessage id="Company.warehousingTextPart3"
                            defaultMessage="Amongst our main principles is the constant investment in expanding our expertise and skillset, new infrastructure and improving organizational workflow."
                            description="Warehousing Service text" />
                        <br />
                        <FormattedMessage id="Company.warehousingTextPart4"
                            defaultMessage="Amongst our main principles is the constant investment in expanding our expertise and skillset, new infrastructure and improving organizational workflow."
                            description="Warehousing Service text" />
                        <br />
                        <FormattedMessage id="Company.warehousingTextPart5"
                            defaultMessage="Amongst our main principles is the constant investment in expanding our expertise and skillset, new infrastructure and improving organizational workflow."
                            description="Warehousing Service text" />
                        <br />
                        <FormattedMessage id="Company.warehousingTextPart6"
                            defaultMessage="Amongst our main principles is the constant investment in expanding our expertise and skillset, new infrastructure and improving organizational workflow."
                            description="Warehousing Service text" />
                        <br />
                        <br />
                        <p id="CompanywarehousingTextPart7">
                        <FormattedMessage id="Company.warehousingTextPart7"
                            defaultMessage="Amongst our main principles is the constant investment in expanding our expertise and skillset, new infrastructure and improving organizational workflow."
                            description="Warehousing Service text" />
                        </p>
                        <p id="CompanywarehousingTextPart8">
                        <FormattedMessage id="Company.warehousingTextPart8"
                            defaultMessage="Amongst our main principles is the constant investment in expanding our expertise and skillset, new infrastructure and improving organizational workflow."
                            description="Warehousing Service text" />
                        </p>    
                        <FormattedMessage id="Company.warehousingTextPart9"
                            defaultMessage="Amongst our main principles is the constant investment in expanding our expertise and skillset, new infrastructure and improving organizational workflow."
                            description="Warehousing Service text" />
                        <br />
                        <FormattedMessage id="Company.warehousingTextPart10"
                            defaultMessage="Amongst our main principles is the constant investment in expanding our expertise and skillset, new infrastructure and improving organizational workflow."
                            description="Warehousing Service text" />
                    </p>
                </div>

                <div className="company-documents-wrapper">
                    <p ref={this.props.sectionRefs.companyDocumentsRef} id="company-documents-title">
                        <FormattedMessage id="Company.documentsTitle"
                            defaultMessage="Company Documents"
                            description="Company Documents title" />
                    </p>
                    <div className="company-documents-list">
                        <CompanyDocumentsList companydocuments={this.props.companydocuments}></CompanyDocumentsList>
                    </div>
                </div>

                <div className="company-contacts-wrapper">
                    <p ref={this.props.sectionRefs.contactsRef} id="company-contacts-title">
                        <FormattedMessage id="Company.contactsTitle"
                            defaultMessage="Contacts"
                            description="Company Contacts" />
                    </p>
                    <p id="company-contacts-text">
                        <p id="CompanycontactsTextPart1">
                        <FormattedMessage id="Company.contactsTextPart1"
                            defaultMessage="You can contact us in Bulgarian, English, German and Russian through the following e-mails:"
                            description="Company contacts text" />
                            <span className="contacts-language-flag">
                                <img id="language-en" className="language-icon-flag" onClick={this.chooseLanguageEn} src="./en.png" alt="English Language"></img>
                                <img id="language-fr" className="language-icon-flag" onClick={this.chooseLanguageEn} src="./fr.png" alt="French Language"></img>
                            </span>
                            </p>
                        <span itemProp="telephone"><a href="tel:+359888106999">
                            +359 888 106 999</a></span>
                        <br />
                        <a href="mailto:office@nikkomersial.com">office@nikkomersial.com</a>
                        <br />
                        <br />
                        <p id="CompanycontactsTextPart2">
                        <FormattedMessage id="Company.contactsTextPart2"
                            defaultMessage="You can contact us in Bulgarian, English, German and Russian through the following e-mails:"
                            description="Company contacts text" />
                            <img id="language-es" className="language-icon-flag" onClick={this.chooseLanguageEs} src="./es.png" alt="Spanish Language"></img>
                            </p>
                        <span itemProp="telephone"><a href="tel:+359889806999">
                            +359 889 806 999</a></span>
                        <br />
                        <a href="mailto:office1@nikkomersial.com">office1@nikkomersial.com</a>
                        <br />
                        <br />
                        <p id="CompanycontactsTextPart3">
                        <FormattedMessage id="Company.contactsTextPart3"
                            defaultMessage="You can contact us in Bulgarian, English, German and Russian through the following e-mails:"
                            description="Company contacts text" />
                            </p>
                        <span itemProp="telephone"><a href="tel:+359882287070">
                            +359 882 287 070</a></span>
                        <br />
                        <a href="mailto:office@nikkomersial.com">office@nikkomersial.com</a>
                        <br />
                        <br />
                    </p>

                    <div id="address-wrapper">
                        <div id="address-company-name">
                            <FormattedMessage id="Company.contactsAddress1"
                                defaultMessage="NIK Komersiel EOOD"
                                description="Company Address" />
                        </div>
                        <br />
                        <div id="address-company-address">
                            <p>
                            <FormattedMessage id="Company.contactsAddress2"
                                defaultMessage="Address:"
                                description="Company Address" />
                            </p>
                            <p>
                            <FormattedMessage id="Company.contactsAddress3"
                                defaultMessage=" Bulgaria, 2700 Blagoevgrad"
                                description="Company Address" />
                            </p>
                            <p>
                            <FormattedMessage id="Company.contactsAddress4"
                                defaultMessage="Radovish street №12"
                                description="Company Address" />
                            </p>
                        </div>
                    </div>
                </div>

                <div id="copyright">
                    <FormattedMessage id="Company.copyright"
                        defaultMessage="Copyright © “NIK Komersiel” LTD"
                        description="Copyright" />
                </div>
                <div className="end-of-page-space">
                </div>
            </div>
        );
    }
}

export default PageContent;